import makeStyles from "@mui/styles/makeStyles";

export const useIconStyles = makeStyles({
  root: {
    fontSize: "48px",
    fill: "white",
  },
});
